.thumbnail {
  position: fixed;
  bottom: 12px;
  left: 12px;
  z-index: 2147483647;
  width: 260px;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dde1e7;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  font-family:
    system-ui,
    -apple-system,
    sans-serif;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  background: #f4f5f7;
  border: none;
  border-bottom: 1px solid #dde1e7;
  cursor: grab;
  text-align: left;
  touch-action: none;
  user-select: none;
}

.header:active {
  cursor: grabbing;
}

.title {
  font-size: 12px;
  font-weight: 700;
  color: #1a1d23;
  margin-right: auto;
}

.statOk {
  font-size: 11px;
  font-weight: 700;
  color: #059669;
}

.statBad {
  font-size: 11px;
  font-weight: 700;
  color: #be185d;
}

.statMuted {
  font-size: 11px;
  color: #6b7280;
}

.chevron {
  font-size: 10px;
  color: #6b7280;
}

.body {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
}

.section {
  border: 1px solid #dde1e7;
  border-radius: 6px;
  overflow: hidden;
}

.sectionHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  color: #ffffff;
}

.sectionLabel {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.sectionMissing {
  font-size: 10px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.25);
  padding: 1px 6px;
  border-radius: 8px;
}

.chips {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
}

.chip,
.chipMissing {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 7px;
  border-radius: 5px;
  border: 1px solid #dde1e7;
  background: #f4f5f7;
}

.chipMissing {
  border-color: #be185d;
  background: #fdf2f8;
}

.chipName {
  flex: 1;
  font-family: ui-monospace, 'Courier New', monospace;
  font-size: 10px;
  color: #1a1d23;
  word-break: break-all;
}

.chipMissing .chipName {
  color: #be185d;
  font-weight: 700;
}

.chipCount {
  font-size: 10px;
  font-weight: 700;
  color: #374151;
  white-space: nowrap;
  flex-shrink: 0;
}

.chipMissing .chipCount {
  color: #be185d;
}
